import React from "react";

const FaqHero = () => {
  return (
    <section className="relative w-full overflow-hidden bg-[color:var(--navy)]">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute -top-44 -right-44 h-[32rem] w-[32rem] rounded-full bg-[color:var(--brand-accent)]/22 blur-3xl" />
        <div className="absolute -bottom-52 -left-52 h-[36rem] w-[36rem] rounded-full bg-[color:var(--brand)]/26 blur-3xl" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/25 to-black/50" />
      </div>

      {/* Content */}
      <div
        className="
          relative mx-auto max-w-7xl
          px-4 sm:px-6 lg:px-8
          py-16
          sm:py-20
          md:py-24
          lg:py-28
        "
      >
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-semibold text-white">
            FAQ
            <span className="h-1.5 w-1.5 rounded-full bg-[color:var(--brand-accent)]" />
            Quick answers
          </div>

          <h1 className="mt-6 text-4xl sm:text-5xl font-semibold tracking-tight text-white">
            Frequently asked questions
          </h1>

          <p className="mt-5 text-base sm:text-lg text-white/85 max-w-2xl">
            Clear answers about training, consulting, compliance support, and how engagements work.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FaqHero;
